(function () {
    
    // Recupero le voci di menu che hanno dei sotto-menu
    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    // Recupero il container dell'haeder
    let header = document.querySelector("sticky-header");
    
    let solodettagli = document.getElementById ('HeaderMenu-marchi-solo-dettagli');
    let deturner = document.getElementById('HeaderMenu-marchi-deturner');
    let royalPads = document.getElementById('HeaderMenu-marchi-royal-pads');
    let monkeyCare = document.getElementById('HeaderMenu-marchi-monkey-car-care');

    solodettagli.style.fontWeight = 800;
    deturner.style.fontWeight = 800;
    royalPads.style.fontWeight = 800;
    monkeyCare.style.fontWeight = 800;
  
    
    items.forEach(item => {
        // Inizializzo ogni menu rimuovendo l'attributo open
        item.addEventListener("mouseenter", () => { 
            items.forEach(item => {
                item.removeAttribute("open");
            });

            // Attribuisco open al menu al passaggio del mouse
            item.setAttribute("open", true); 

            // Rimuovo l'attributo open se il puntatore esce al di fuori del container dell'header
            header.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
            })

           
            let ulElement = item.querySelector("ul");

            // Rimuovo l'attributo open se il puntatore esce al di fuori delle voci di sotto-menu
            ulElement.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
            });
            
        } );
    });

    })();